<template>
    <v-col cols="12" xl="10" class="px-0">
        <v-row>
            <v-col cols="12">
                <h5>{{ t('collection-centre::form.title.general_information') }}</h5>
            </v-col>
            <v-col cols="12" lg="6" class="pt-0">
                <b-input
                    to-mutate="laboratories::collection_centre.name"
                    :label="t('collection-centre::form.label.name')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.name"
                    mandatory
                ></b-input>
            </v-col>
            <v-col cols="12" lg="6" class="pt-0">
                <div style="width: max-content" class="pl-2 pl-md-0">
                    <b-switch
                        to-mutate="laboratories::collection_centre.is_registered"
                        :label="t('collection-centre::form.label.registered')"
                        :readonly="readOnlyRules"
                        :rules="validationRules.is_registered"
                    ></b-switch>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <h5>{{ t('collection-centre::form.title.address') }}</h5>
            </v-col>
            <v-col cols="12" lg="6" class="pt-0">
                <b-input
                    to-mutate="laboratories::collection_centre.address"
                    :label="t('collection-centre::form.label.address')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.address"
                    mandatory
                ></b-input>
            </v-col>
            <v-col cols="12" lg="6" class="pt-0">
                <b-input
                    to-mutate="laboratories::collection_centre.post_code"
                    :label="t('collection-centre::form.label.post_code')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.post_code"
                    mandatory
                ></b-input>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <h5>{{ t('collection-centre::form.title.contact_details') }}</h5>
            </v-col>
            <v-col cols="12" lg="6" class="py-0">
                <b-input
                    to-mutate="laboratories::collection_centre.phone"
                    :label="t('collection-centre::form.label.phone')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.phone"
                    mandatory
                ></b-input>
            </v-col>
            <v-col cols="12" lg="6" class="py-0">
                <b-input
                    to-mutate="laboratories::collection_centre.fax"
                    :label="t('collection-centre::form.label.fax')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.fax"
                ></b-input>
            </v-col>
            <v-col cols="12" lg="6" class="pt-0">
                <b-input
                    to-mutate="laboratories::collection_centre.email"
                    :label="t('collection-centre::form.label.email')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.email"
                    mandatory
                ></b-input>
            </v-col>
            <v-col cols="12" lg="6" class="pt-0">
                <b-input
                    to-mutate="laboratories::collection_centre.contacts_information"
                    :label="t('collection-centre::form.label.contacts')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.contacts_information"
                ></b-input>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <h5>{{ t('collection-centre::form.title.courier') }}</h5>
            </v-col>
            <v-col cols="12" lg="6" class="pt-0">
                <b-input
                    to-mutate="laboratories::collection_centre.courier_details"
                    :label="t('collection-centre::form.label.courier_details')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.courier_details"
                ></b-input>
            </v-col>
            <v-col cols="12" lg="6" class="pt-0">
                <b-input
                    to-mutate="laboratories::collection_centre.courier_phone"
                    :label="t('collection-centre::form.label.courier_phone')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.courier_phone"
                ></b-input>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
export default {
    data() {
        return {
            readOnlyRules: !this.can('api.v1.collection-centres.update') && this.can('api.v1.collection-centres.show'),
            validationRules: {
                name: [(v) => !!v || t('users::validation.field.required')],
                address: [(v) => !!v || t('users::validation.field.required')],
                post_code: [(v) => !!v || t('users::validation.field.required'), this.$root.rules.postCode],
                phone: [(v) => !!v || t('users::validation.field.required'), this.$root.rules.phone],
                fax: [this.$root.rules.fax],
                email: [(v) => !!v || t('users::validation.field.required'), this.$root.rules.email],
                contacts_information: [],
                courier_name: [(v) => !!v || t('users::validation.field.required')],
                courier_phone: [this.$root.rules.phone],
            },
        };
    },
};
</script>

<style></style>
